import React from "react";
import PropTypes from "prop-types";

function EmptyBodyIcon() {
  return (
    <svg width="63" height="75" viewBox="0 0 63 75" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M31.4997 70.1395C48.8965 70.1395 62.9994 56.0366 62.9994 38.6398C62.9994 21.243 48.8965 7.14014 31.4997 7.14014C14.1029 7.14014 0 21.243 0 38.6398C0 56.0366 14.1029 70.1395 31.4997 70.1395Z"
        fill="#C1C7CD"
      />
      <path
        d="M49.5595 25.1997H13.4398C12.28 25.1997 11.3398 26.1399 11.3398 27.2997V71.3992C11.3398 72.559 12.28 73.4992 13.4398 73.4992H49.5595C50.7192 73.4992 51.6594 72.559 51.6594 71.3992V27.2997C51.6594 26.1399 50.7192 25.1997 49.5595 25.1997Z"
        fill="white"
      />
      <path
        d="M27.299 31.4998H16.3791C15.6833 31.4998 15.1191 32.0639 15.1191 32.7597C15.1191 33.4556 15.6833 34.0197 16.3791 34.0197H27.299C27.9949 34.0197 28.559 33.4556 28.559 32.7597C28.559 32.0639 27.9949 31.4998 27.299 31.4998Z"
        fill="#F5F9FF"
      />
      <path
        d="M34.8589 36.9597H16.3791C15.6833 36.9597 15.1191 37.5238 15.1191 38.2197C15.1191 38.9156 15.6833 39.4797 16.3791 39.4797H34.8589C35.5548 39.4797 36.1189 38.9156 36.1189 38.2197C36.1189 37.5238 35.5548 36.9597 34.8589 36.9597Z"
        fill="#C1C7CD"
      />
      <path
        d="M27.299 42.8394H16.3791C15.6833 42.8394 15.1191 43.4035 15.1191 44.0993C15.1191 44.7952 15.6833 45.3593 16.3791 45.3593H27.299C27.9949 45.3593 28.559 44.7952 28.559 44.0993C28.559 43.4035 27.9949 42.8394 27.299 42.8394Z"
        fill="#F5F9FF"
      />
      <path
        d="M34.8589 48.2998H16.3791C15.6833 48.2998 15.1191 48.8639 15.1191 49.5598C15.1191 50.2557 15.6833 50.8198 16.3791 50.8198H34.8589C35.5548 50.8198 36.1189 50.2557 36.1189 49.5598C36.1189 48.8639 35.5548 48.2998 34.8589 48.2998Z"
        fill="#C1C7CD"
      />
      <path
        d="M27.299 54.1794H16.3791C15.6833 54.1794 15.1191 54.7436 15.1191 55.4394C15.1191 56.1353 15.6833 56.6994 16.3791 56.6994H27.299C27.9949 56.6994 28.559 56.1353 28.559 55.4394C28.559 54.7436 27.9949 54.1794 27.299 54.1794Z"
        fill="#F5F9FF"
      />
      <path
        d="M34.8589 59.6396H16.3791C15.6833 59.6396 15.1191 60.2038 15.1191 60.8996C15.1191 61.5955 15.6833 62.1596 16.3791 62.1596H34.8589C35.5548 62.1596 36.1189 61.5955 36.1189 60.8996C36.1189 60.2038 35.5548 59.6396 34.8589 59.6396Z"
        fill="#C1C7CD"
      />
      <path
        d="M49.5595 3.78003H13.4398C12.28 3.78003 11.3398 4.72022 11.3398 5.88001V18.4799C11.3398 19.6397 12.28 20.5799 13.4398 20.5799H49.5595C50.7192 20.5799 51.6594 19.6397 51.6594 18.4799V5.88001C51.6594 4.72022 50.7192 3.78003 49.5595 3.78003Z"
        fill="#DDE1E5"
      />
      <path
        d="M27.299 8.3999H16.3791C15.6833 8.3999 15.1191 8.96402 15.1191 9.65989C15.1191 10.3558 15.6833 10.9199 16.3791 10.9199H27.299C27.9949 10.9199 28.559 10.3558 28.559 9.65989C28.559 8.96402 27.9949 8.3999 27.299 8.3999Z"
        fill="#F5F9FF"
      />
      <path
        d="M34.8589 13.8601H16.3791C15.6833 13.8601 15.1191 14.4242 15.1191 15.1201C15.1191 15.816 15.6833 16.3801 16.3791 16.3801H34.8589C35.5548 16.3801 36.1189 15.816 36.1189 15.1201C36.1189 14.4242 35.5548 13.8601 34.8589 13.8601Z"
        fill="white"
      />
      <path
        d="M47 31.6467L42 36.6467M42 31.6467L47 36.6467"
        stroke="#DDE1E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function CardEmptyBody({ message }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "24px 0 4px",
      }}
    >
      <div style={{ fontSize: 15, color: "#4d5357", marginBottom: 18 }}>{message}</div>
      <EmptyBodyIcon />
    </div>
  );
}

CardEmptyBody.propTypes = {
  message: PropTypes.string.isRequired,
};
